import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import AppealOutcomeComponent from "../../components/applicationComponents/appealOutcome/AppealOutcomeComponent";

export default function AppealOutcomePage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Appeal Outcome",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <AppealOutcomeComponent disabled={false} />
    </>
  );
}
